import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Visa } from '@app/interfaces';
import { map, Observable, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VisaService {
  private visas: Visa[];

  constructor(private http: HttpClient) {
    this.visas = [];
  }

  getAll(): Observable<Visa[]> {
    if (this.visas.length > 0) return of(this.visas);

    return this.http
      .get<Visa[]>(`${environment.serverUrl}/visa/visa`)
      .pipe(tap((visas) => (this.visas = visas)));
  }

  getAllCurrency() {
    let clean = new Set<string>();

    return this.getAll().pipe(
      map((visas) =>
        visas
          .filter((v) => v.CurrencyCode)
          .map((visa) => visa.CurrencyCode ?? '')
      ),
      map((currencyCodes) =>
        currencyCodes.filter((code) => {
          if (clean.has(code)) return false;
          clean.add(code);
          return true;
        })
      )
    );
  }

  getAllCountries() {
    return this.getAll().pipe(
      map((visas) => visas.map((visa) => visa.Name ?? ''))
    );
  }

  getAllIndicatives() {
    let clean = new Set<string>();

    return this.getAll().pipe(
      map((visas) => visas.filter((v) => v.WP).map((visa) => visa.WP ?? '')),
      map((Wp) =>
        Wp.filter((code) => (clean.has(code) ? false : (clean.add(code), true)))
      ),
      map((data) => data.sort((a: any, b: any) => a - b))
    );
  }
}
